// Animasyonlu/video bir görsel kaynağının (webp/gif/mp4...) "referans görseli"
// — idealStudioFiles.reference_id ile türetildiği dosya — var mı? Dışarıdan
// import edilen medyanın job zinciri olmadığından orijinali yoktur; Aidea
// Wizard ("Görseli Canlandır") orada boş açılır, bu yüzden aksiyon kapatılır.
// fetcher(url) → Promise<boolean> (bkz. server_utils fetchHasReferenceImage).
// Sonuç url başına cache'lenir (her seçimde yeniden istek atılmaz).
const NON_STATIC_RE = /\.(mp4|webm|mov|m4v|webp|gif)(\?|#|$)/i;

const cache = new Map(); // url → boolean
const inflight = new Map(); // url → Promise<boolean>

export const isNonStaticMediaUrl = (url) => !!url && NON_STATIC_RE.test(url);

export const getCachedHasReferenceImage = (url) => cache.get(url);

export function resolveHasReferenceImage(url, fetcher) {
  if (cache.has(url)) return Promise.resolve(cache.get(url));
  if (inflight.has(url)) return inflight.get(url);
  const p = Promise.resolve()
    .then(() => fetcher(url))
    .then((has) => has === true)
    .catch(() => false)
    .then((has) => {
      cache.set(url, has);
      inflight.delete(url);
      return has;
    });
  inflight.set(url, p);
  return p;
}

export function __resetReferenceImageCache() {
  cache.clear();
  inflight.clear();
}
